import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-c3-three-four-three-one',
  templateUrl: './c3-three-four-three-one.component.html',
  styleUrls: ['./c3-three-four-three-one.component.scss']
})
export class C3ThreeFourThreeOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
